import React from 'react';

export default class Servcies extends React.Component {
    render () {
        return (
            <section id="services" className="services">
          <div className="container">

            <div className="section-title">
              <h2>Services</h2>
              <p>The services that I provide are solely based on creating websites including clothing brands, sports, music, personal landing pages, online stores or shopping businesses.  </p>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-6 icon-box" data-aos="fade-up">
                <div className="icon"><i className="bi bi-briefcase"></i></div>
                <h4 className="title"><a href="">Web Design</a></h4>
                <p className="description">Designing your website to ensure that the appearance, layout, and visual capabilities are effective can lead to a successful website. </p>
              </div>
              <div className="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="100">
                <div className="icon"><i className="bi bi-card-checklist"></i></div>
                <h4 className="title"><a href=""> Branding </a></h4>
                <p className="description"> Creating a website can increase your Brand authenicity and recall value for your personal business. </p>
              </div>
              <div className="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="200">
                <div className="icon"><i className="bi bi-bar-chart"></i></div>
                <h4 className="title"><a href="">Development</a></h4>
                <p className="description">Developing the website that meets the client needs. </p>
              </div>
              <div className="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="300">
                <div className="icon"><i className="bi bi-binoculars"></i></div>
                <h4 className="title"><a href=""> Ecommerce </a></h4>
                <p className="description"> There are various of projects completed using the leading system for WordPress, which is called WooCommerce for fully functional store.  </p>
              </div>
              <div className="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="400">
                <div className="icon"><i className="bi bi-brightness-high"></i></div>
                <h4 className="title"><a href=""> Wordpress</a></h4>
                <p className="description"> WordPress is a platform where you can host and build new websites, I can help you with themes, plugins, functions and more on your install. </p>
              </div>
              <div className="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="500">
                <div className="icon"><i className="bi bi-calendar4-week"></i></div>
                <h4 className="title"><a href=""> Landing Page </a></h4>
                <p className="description"> landing page is created for those who need a new app, event, ebook or anything else you need to sell, a landing page will ensure high-conversions. </p>
              </div>
            </div>

          </div>
        </section>

        )
    }
}